/* eslint-disable */
import React, { Component } from 'react';
import { View, Text, StyleSheet } from 'react-native';
import styles from './Styles/SpacerStyles'
// create a component
class Spacer extends Component {
  render() {
    return (
      <View style={[styles.small,this.props.style]} />
    );
  }
}

export default Spacer
